import React from 'react';
import { Layout } from '../components/Layout';

export default function Privacy() {
    return (
        <Layout>
            <div className="min-h-screen py-24">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="font-brand text-4xl md:text-5xl uppercase mb-8">
                        Privacy <span className="text-primary">Policy</span>
                    </h1>
                    
                    <div className="prose prose-invert prose-sm max-w-none space-y-6 text-muted-foreground">
                        <p className="text-foreground">
                            Last updated: February 1, 2026
                        </p>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">1. Information We Collect</h2>
                            <p>
                                When you use SubHack, we collect:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li><strong>Account Information:</strong> Email address and encrypted password when you register.</li>
                                <li><strong>Third-Party Auth:</strong> If you use Google Login, we receive your email, name, and profile picture.</li>
                                <li><strong>Content:</strong> Subtitles you create, styling preferences, and project metadata.</li>
                                <li><strong>Usage Data:</strong> Pages visited, features used, device type, and interaction patterns.</li>
                                <li><strong>Payment Data:</strong> Processed securely by Lemon Squeezy (we do not store credit card numbers).</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">2. How We Use Your Information</h2>
                            <p>
                                We use your information to:
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Provide, maintain, and improve the Service</li>
                                <li>Process transactions and manage subscriptions</li>
                                <li>Send service-related notices (e.g., security alerts, updates)</li>
                                <li>Detect and prevent fraud, abuse, and security incidents</li>
                                <li>Comply with legal obligations</li>
                            </ul>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">3. Analytics & Advertising</h2>
                            <p>
                                We may use third-party service providers (such as Google Analytics or Meta Pixel) to monitor and analyze the use of our Service. 
                                These entities may use cookies, web beacons, and other tracking technologies to collect information about your activity on our Service 
                                to help us understand user behavior and improve our marketing efforts.
                            </p>
                            <p>
                                You can opt out of certain tracking features by adjusting your device or browser settings, or by visiting the 
                                Network Advertising Initiative opt-out page.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">4. Data Storage & Sharing</h2>
                            <p>
                                Your data is stored on secure servers (MongoDB, Cloudflare R2). We do not sell your personal data. 
                                We may share data with trusted third-party service providers (e.g., OpenAI for moderation, Lemon Squeezy for payments) 
                                solely for the purpose of providing the Service.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">5. Regional Privacy Rights</h2>
                            
                            <h3 className="font-heading text-lg text-foreground mt-4">GDPR (EEA and UK)</h3>
                            <p>
                                If you are a resident of the European Economic Area (EEA), you have the right to request access to, correction of, 
                                or deletion of your personal data; portability of your data; and restriction of or objection to processing.
                            </p>

                            <h3 className="font-heading text-lg text-foreground mt-4">California (CCPA/CPRA)</h3>
                            <p>
                                We do not sell your personal information. California residents may request:
                            </p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li>Disclosure of the categories and specific pieces of personal information we have collected.</li>
                                <li>Deletion of personal information we have collected from you.</li>
                                <li>Correction of inaccurate personal information.</li>
                            </ul>
                            <p className="mt-2">
                                To exercise these rights, please contact us at <span className="text-primary">caconsumer@atrv.io (for CCPA/CPRA)</span> or <span className="text-primary">gdpr@atrv.io (for GDPR)</span> with the subject line "Privacy Request".
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">6. Children's Privacy</h2>
                            <p>
                                SubHack is not intended for users under 13 years of age. We do not knowingly collect personal information from children under 13. 
                                If we become aware that we have collected such information, we will take steps to delete it.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">7. Changes to This Policy</h2>
                            <p>
                                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                            </p>
                        </section>

                        <section className="space-y-4">
                            <h2 className="font-heading text-xl uppercase text-foreground">8. Contact Us</h2>
                            <p>
                                For privacy-related questions, data export requests, or to contact our Data Protection Officer:
                            </p>
                            <div className="bg-muted p-4 rounded-lg text-sm font-mono mt-2">
                                <p>All the Rage Ventures, LLC</p>
                                <p>Attn: Privacy Team</p>
                                <p>P.O. Box 78</p>
                                <p>Somers, NY 10589</p>
                                <p className="mt-2 text-primary">Email: subhacksupport@atrv.io</p>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}